module.exports = __webpack_public_path__ + "static/media/error.d5d84bc9.png";